__turbopack_context__.v({
  "tooltip": "rules-tooltip-module__HGRRWa__tooltip",
});
